import { combineReducers } from "redux";

import search from "./search";
import trip from "./trip";
import seats from "./seats";
import payment from "./payment";
import notification from './notification'

export default combineReducers({ search, trip, seats, payment, notification });
